export default __webpack_public_path__ + "static/media/default.4cdc2bbd2ed4cac9207044088cbc6357.svg";